import {
  BridgeHTTPClient,
  BridgeHTTPRequestConfig,
  createHTTPClient,
} from '@smartsheet-bridge/bridge-sdk/es/http';
import { getDefaultHeaders, http } from '../../../utils/apiRequests';

// TODO: Refactor this as part of bridge-sdk
export interface Workflow {
  createTime?: number;
  delete?: number;
  intent: string;
  keys?: {};
  lastUpdateTime?: number;
  orderBy?: number;
  objectUUID: string;
  serviceOwner?: string;
  startState?: string;
  isSystem?: boolean;
  transits?: {};
  answer?: string;
  workspace?: string;
  objectReferences?: [
    {
      subjectUUID: string;
      subjectType: string;
      referenceData: {
        entitydata: {};
        triggerdetails: {
          intent?: string;
          state?: string;
          eventType?: string;
          sheetID?: string;
          sheetName: {};
        };
      };
    }
  ];
  transient?: boolean;
  isModified?: boolean;
}

export interface Phrases {
  intent: string;
  phrases: string[];
  contexts: { [key: string]: string };
}

export interface Webhook {
  event_type: string;
  name: string;
  url: string;
}

export const getWorkflow = async (
  workflowUUID: string,
  httpFunc: (request: RequestInfo, config: any) => any = http
) => {
  const url = `/api/conversation/${workflowUUID}`;

  const headers = getDefaultHeaders();

  const config = {
    method: 'get',
    headers,
  };

  const response = await httpFunc(url, config);
  const json = await response.json();

  return json;
};

// BridgeSDK Setup
let API: BridgeHTTPClient;

const getAPI = () => {
  if (!API) {
    API = createHTTPClient({
      baseURL: '/api',
    });

    API.instance.interceptors.request.use((config: BridgeHTTPRequestConfig) => {
      const sessionToken = localStorage.getItem('converse_authkey');
      if (sessionToken) {
        API.instance.defaults.token = JSON.parse(sessionToken);
      }
      const sessionWorkspace = sessionStorage.getItem(
        'converse:active_workspace'
      );
      if (sessionWorkspace) {
        API.instance.defaults.workspace = JSON.parse(sessionWorkspace);
      }

      return config;
    });
  }
  return API;
};

export const saveWorkflow = async (
  workflow: Workflow,
  httpFunc: (request: RequestInfo, config: any) => any = http
) => {
  const headers = getDefaultHeaders();

  const url = `/api/conversation/${window.encodeURIComponent(
    workflow.objectUUID || workflow.intent
  )}`;

  const config = {
    method: 'put',
    headers,
    body: JSON.stringify(workflow),
  };

  const response = await httpFunc(url, config);
  const json = await response.json();
  return json;
};

export const createWorkflow = async (
  workflow: Workflow,
  httpFunc: (request: RequestInfo, config: any) => any = http
) => {
  const config = {
    method: 'post',
    data: workflow,
  };
  const response = await httpFunc('/api/conversation/', config);
  const json = await response.json();
  return json;
};

export const createRequest = async (
  httpFunc: (request: RequestInfo, config: any) => any = http
) => {
  const url = '/api/request';

  const headers = getDefaultHeaders();

  const config = {
    method: 'POST',
    headers,
  };

  const response = await httpFunc(url, config);
  const json = response.json();

  return json;
};

export const createConversationComment = async (
  requestUUID: string,
  data: any,
  httpFunc: (request: RequestInfo, config: any) => any = http
) => {
  const url = `/api/request/${requestUUID}/conversation`;

  const headers = getDefaultHeaders();

  const config = {
    method: 'post',
    headers,
    body: JSON.stringify(data),
  };

  const response = await httpFunc(url, config);
  const json = await response.json();

  return json;
};

export const startWorkflowRun = (intent: string) => {
  createRequest().then(data => {
    createConversationComment(data.objectUUID, {
      intent: intent,
      entities: {},
    });
  });
};

export const stopWorkflowRun = async (
  requestUUID: string,
  httpFunc: (request: RequestInfo, config: any) => any = http
) => {
  const url = `/api/conversation/${requestUUID}/stop`;

  const headers = getDefaultHeaders();

  const config = {
    method: 'post',
    headers,
  };

  const response = await httpFunc(url, config);

  return response;
};

export default getAPI();
